module.exports = __webpack_public_path__ + "static/img/nulldata.2d731faa.png";